'use strict';

var { findWhere } = require('underscore'),
    AppDispatcher = require('../AppDispatcher'),
    StampStore = require('./StampStore'),
    getAllStampImages = require('../utils/getAllStampImages'),
    { createStore, mergeIntoBag, isInBag } = require('../utils/StoreUtils');

var images = {};

var ImageStore = createStore({
  contains(slug, fields) {
    return isInBag(images, slug, fields);
  },

  get(id) {
    return images[id];
  },

  getInStamp(id, stampId) {
    var image = this.get(id),
        stamp = StampStore.get(stampId);

    if (!id || !stamp || !stamp.content) {
      return;
    }

    if (!image) {
      image = findWhere(
        getAllStampImages(stamp),
        { uuid: id }
      );
    }

    return image;
  },

  getSourceImage(image) {
    if (!this.contains(image.uuid)) {
      return image;
    }

    image = this.get(image.uuid);

    if (image.sourceImage) {
      return this.get(image.sourceImage);
    } else {
      return image;
    }
  },

  getSourceStamp(image, currentStampId) {
    var sourceImage = this.getSourceImage(image);
    return StampStore.get(sourceImage.stamp || currentStampId);
  },

  getUsageCount(image) {
    var sourceImage = this.getSourceImage(image);
    return sourceImage.usageCount || 0;
  },

  isInGrabbag(image) {
    var sourceImage = this.getSourceImage(image);
    return sourceImage.isInGrabbag || false;
  }
});

ImageStore.dispatchToken = AppDispatcher.register(function (payload) {
  var action = payload.action,
      response = action.response,
      entities = response && response.entities,
      receivedImages = entities && entities.images;

  if (receivedImages) {
    mergeIntoBag(images, receivedImages);
    ImageStore.emitChange();
  }
});

module.exports = ImageStore;


/** WEBPACK FOOTER **
 ** ./stores/ImageStore.js
 **/